module.exports = __webpack_public_path__ + "static/img/top-img.14d53ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/detailpic/UC3880/top-img.jpg
// module id = DAXE
// module chunks = 51